// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import BootstrapVue from 'bootstrap-vue'

import App from './App'
import router from './router'
var VueCookie = require('vue-cookie');
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
// import GAuth from 'vue-google-oauth2'
// Tell Vue to use the plugin

const gauthOption = {
  clientId: '1012521711276-gp1lvs9lj85nbela598vecavilimuld7.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}

// Vue.use(GAuth, gauthOption)
Vue.use(VueCookie);
Vue.use(VueMoment, {
    moment,
})
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../static/style.css'
axios.defaults.baseURL = 'https://api.tradingapp.pro/'
axios.interceptors.response.use(function (response) {
  // console.log(response.data)
  if (response.data.redirect) {
    router.push(response.data.redirect)
  }
  return response
}, function (error) {
  // Do something with response error
  return Promise.reject(error)
})

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
// Vue.use(createChart)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js